<template>
    <div class="medical-records">
        <div class="row mr-0 Nutrition-questionair">
            <div class="col-12">
                <div class="card border-0">
                    <div class="card-body bg-white border-radius-5 d-flex">
                        <div class="row no-gutters align-items-center justify-content-center p-5 supplement-ingredients">
                            <div class="col-md-6 text-center p-4">
                                <h2 class="mb-4">
                                    Your supplement ingredients <br />
                                    can change
                                </h2>
                                <p class="mb-4">We will add, adjust and remove ingredients on this side depending on your answers.</p>
                                <em>Every answer will get you closer to your perfect formula.</em>
                            </div>
                            <div class="col-md-5 text-center p-4">
                                <h2 class="mb-3">What is your name?</h2>
                                <form>
                                    <input type="text" name="text" placeholder="Enter your first name" class="mb-4" />
                                    <router-link to="/custom-suppliment-deatil" class="btn btn-blue btn-continue">Continue</router-link>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Nutrition",
        data() {
            return {

            }
        },
        created(){
           this.pageName('Nutrition and Supplements');
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/website/nutrition/pages/custom-suppliment-questionaries.vue